import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

/**
 * @deprecated [fabric-deprecated] - use NationalDataService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class NationalDataConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getBirthProvincesEndpoint(): string {
		return this.configService.get(
			(x) => x.common.nationalData?.endpoints?.birthProvinces,
			"v2/it/nationaldata/birthprovinces"
		);
	}

	getCountryCitiesEndpoint(): string {
		return this.configService.get((x) => x.common.nationalData?.endpoints?.countryCities, `i18n/v3/countries/it`);
	}

	getCountryByTaxCodeEndpoint(): string {
		return this.configService.get(
			(x) => x.common.nationalData?.endpoints?.countryByTaxCodeFragment,
			`v2/it/nationaldata/countries/`
		);
	}

	getTaxCodeByCountryEndpoint(): string {
		return this.configService.get(
			(x) => x.common.nationalData?.endpoints?.taxCodeFragmentByCountry,
			`v2/it/nationaldata/taxCodeFragments/`
		);
	}

	getAddStateCodeToCities(): boolean {
		return this.configService.get((x) => x.common.nationalData?.addStateCodeToCities, false);
	}
}
